export const SHOULD_NOT_SEE_LANDING_PAGE = 'SHOULD_NOT_SEE_LP';
